import React, { useEffect } from "react";
import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import LoginForm from "./modules/LoginForm";
import CustomerView from "./modules/CustomerView";
import RecentTrip from "./components/trips/Trips";
import DetailPage from "./modules/DetailPage/Index";

import ImagePicker from "./modules/common/ImagePicker";
import ShareButton from "./modules/common/ShareButton/ShareWhite";
import SlideInModal from "./modules/common/SlideInModal";
import CreateTrip from "./modules/CreateTrip";
import NewTrip from "./components/NewTrip";
import { handleSession } from "./util";
import RedirectPage from "./modules/CustomerView/RedirectPage";
import ErrorPage from "./modules/CustomerView/ErrorPage";
import Trips from "./components/trips/Trips";
import ViewTrip, { MemoViewTrip } from "./modules/CustomerView/ViewTrip";
import TitlePage from "./components/trips/TitlePage";
import Overview from "./components/overview/overview";
import AddNewPlace from "./components/addNewPlace/AddNewPlace";
import AddNotes from "./components/notes/AddNotes";
import Searchin from "./components/Searchin";
import ViewTripHome from "./modules/CustomerView/ViewTrip/";
import ReactGA from "react-ga4";
import DateRange from "./components/dateRange/DateRangeComp";
import Explore from "./external_modules/Explore/Explore";
// import LandingPage from './modules/LandingPage';
// Google Analytics
ReactGA.initialize("G-NPGP4VVL1M");

// disable GA for localhost and admin:
var host = window.location.hostname;
if (host === "localhost" || host === "trips-creator.unravelapp.com") {
  console.log(host + " Analytics Disable");
  window["ga-disable-G-NPGP4VVL1M"] = true; //
}

function App() {
  useEffect(() => {
    // ReactGA.pageview(window.location.pathname + window.location.search)
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, []);

  return (
    <Routes>
      <Route index element={<LoginForm />} />
      <Route path="error" element={<ErrorPage />} />
      <Route path="triplanding/*" element={<CustomerView />} />
      <Route path="trip" element={<RedirectPage />} />
      <Route path="triplanding/viewtrip" element={<ViewTripHome />} />
      <Route path="triplanding/viewtrip/detail-page" element={<DetailPage />} />
      <Route
        path="recenttrip/trip/create-trip/searchin"
        element={<Searchin />}
      />
      <Route
        path="recenttrip/trip/create-trip/date-range"
        element={<DateRange />}
      />

      <Route path="newtrip/" element={<Trips />} />
      <Route path="recenttrip/filterpage" element={<TitlePage />} />
      <Route path="recenttrip" element={<RecentTrip />} />
      <Route
        path="recenttrip/trip/create-trip/overview"
        element={<Overview />}
      />
      <Route
        path="recenttrip/trip/create-trip/overview/addnewplaces"
        element={<AddNewPlace />}
      />
      <Route
        path="recenttrip/trip/create-trip/overview/add-notes"
        element={<AddNotes />}
      />
      <Route path="/recenttrip/trip/create-trip" element={<NewTrip />}></Route>

      {/* Explore Page */}
      {/* <Route path="/Explore" element={<Explore />}></Route> */}
    </Routes>
  );

  // {/* <Route path="create-trip" element={<CreateTrip />}></Route> */}
  // return transitions((props, item) => (
  //   <animated.div style={props}>
  //     <Routes location={item}>
  //       <Route index element={< CustomerView/>} />
  //         <Route path='welcome' >
  //           <Route index={true} element={<WelcomePage />}/>
  //           <Route index={true} element={<WelcomePage />}/>
  //           <Route path='tabs/*' element={<Tabs/>}/>
  //           <Route path='imagepicker' element={<ImagePicker/>}/>
  //           <Route path='webshare' element={<ShareButton/>}/>
  //           <Route path='modal' element={<SlideInModal/>}/>
  //           <Route path='dragndrop' element={<DraggableList/>}/>
  //         </Route>
  //     </Routes>
  //   </animated.div>
  // ))
}

export default App;
